import type { TrialEligibility, TssApiContract } from "@jti/rest-api-types";

import { Rest } from "../../Rest";

/** @deprecated Legacy proxy implementation — superseded by EVO. To be deleted after production verification. */
export class TssApiLegacy extends Rest implements TssApiContract {
  constructor(
    baseUrl: string,
    protected tenantToken: string,
    protected ciamToken: string
  ) {
    super(baseUrl);
    this.setCommonHeader("X-DES-AK-TENANT-TOKEN", this.tenantToken);
    this.ciamToken && this.setCommonHeader("X-DES-CONSUMER-IAM-TOKEN", this.ciamToken); // TSS auth header
    this.ciamToken && this.setCommonHeader("X-DES-USER-TOKEN", this.ciamToken); // EVO auth header
  }

  async getEligibility({ categoryId, userId }: { categoryId: string; userId: string }): Promise<boolean> {
    try {
      const { is_eligible } = await this.request<TrialEligibility>(`/is-eligible/${categoryId}/${userId}`);
      return is_eligible;
    } catch {
      return false;
    }
  }
}
